import {GameFilterDefinitionBase} from "../game-filter-definition-base";
import {GameInfo} from "../../../games/game-info";
import {ApplyGameFilterResult} from "../../evaluators/game-filter-evaluator.interface";
import {GAME_GROUP} from "../../../../../common/const/game_groups_consts";

export abstract class LiveGameFilterDefinitionBase extends GameFilterDefinitionBase {

    protected abstract get textToSearchInSubgroupName(): string;

    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
        if (gameInfo.gameGroupId !== GAME_GROUP.LIVE_CASINO || !gameInfo.subGroupName) {
            return ApplyGameFilterResult.ExcludeGame;
        }

        const subgroupName = gameInfo.subGroupName.toLowerCase();
        if (subgroupName && subgroupName.indexOf(this.textToSearchInSubgroupName) !== -1) {
            return ApplyGameFilterResult.IncludeGame;
        }

        return ApplyGameFilterResult.ExcludeGame;
    }
}